module.exports = __webpack_public_path__ + "static/media/32.2b72b449.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/style/img/borders/32.jpg
// module id = 722
// module chunks = 0